import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  capreseCAEndDate,
  capreseCAStartDate,
  thanksgivingSubCAEndDate,
  thanksgivingSubCAStartDate,
} from '../constants';

export type LtoContentCAProps = {
  default?: ReactNode;
  caprese: ReactNode;
  thanksgivingSub: ReactNode;
};

export const LtoContentCA = ({
  caprese,
  thanksgivingSub,
  default: defaultContent,
}: LtoContentCAProps) => {
  return (
    <DatetimeShow
      after={thanksgivingSubCAStartDate}
      before={thanksgivingSubCAEndDate}
      default={
        <DatetimeShow after={capreseCAStartDate} before={capreseCAEndDate} default={defaultContent}>
          {caprese}
        </DatetimeShow>
      }
    >
      {thanksgivingSub}
    </DatetimeShow>
  );
};
